var custShopLocation;
var product_variants_meta;

if (window.localStorage.getItem('cart-bundled') == 'true') {
  fetch('/cart.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      verifyCartContents(cart, false, false);
    });
}

function getQuantity (lowest = 1) {
  let quantity = $('.quantity-input').val();

  if (quantity == null) {
    quantity = 1;
  }
  else {
    quantity = Number (quantity);
  }

  if (quantity < lowest){
    quantity = lowest;
    $('.quantity-input').val(lowest);
  }

  return quantity;
}

const filterForSingleBundle = (currentMetafields) => {
    const filteredMetafields = currentMetafields.filter(({ id, metafields } ) => {
      const { number_in_bundle } = metafields;
      if (number_in_bundle === 1){
        return true
      } 
      return false
    })
    return filteredMetafields
}
const filterMetafieldsByWholeSale = (currentMetafields) => {
  const filteredMetafields = currentMetafields.filter(({ metafields }) => {
    const { wholesale } = metafields;
    return isWholesale === wholesale
  })
    return filteredMetafields
  }

  const filterMetafieldsByQuantity = (quantity, currentMetafields) => {
    const filteredMetafields = currentMetafields.filter(({ id, metafields } ) => {
      const { applies_to_end_amount, applies_to_starting_amount } = metafields;
      if (quantity >= applies_to_starting_amount && quantity <= applies_to_end_amount){
        return true
      } 
      return false
    })
    return filteredMetafields
  }

  const filterMetafieldsByCountry = (location, quantity, currentMetafields, ignoreBundle = false) => {
    const filteredMetafields = currentMetafields.filter(({ id, metafields } ) => {
      const { inventory_levels, number_in_bundle, inventory_policy } = metafields;
      const countryInventoryLevel = inventory_levels[location];

      let _quantity = quantity;

      if (ignoreBundle === false) {
        _quantity = Math.floor(quantity / number_in_bundle)
      }
      
      if (inventory_policy === 'continue') {
        return true;
      } else if (countryInventoryLevel >= _quantity && countryInventoryLevel !== 0){
        return true
      }

      return false
    })
    return filteredMetafields
  }

  const sortMetafieldsByBundleCount = (filteredMetafields) => {
    filteredMetafields.sort((a, b) => b.metafields.number_in_bundle - a.metafields.number_in_bundle)
    return filteredMetafields
  }

  const fillCart = (quantity, filteredMetafields) => {
    const metafield = filteredMetafields [0];

    if (metafield == null) {
      return [];
    }

    const { id } = metafield;

    return [{
      id,
      quantity,
      location: custShipLocation
    }]
  }

  const fillCartWithAppropriateBundles = (quantity, filteredMetafields, allowBundle = false) => {
    let quantityToFulfill = quantity;

      window.localStorage.setItem('cart-bundled', allowBundle ? 'true' : 'false');

      const data = [];
      for (let i = 0 ; i < filteredMetafields.length ; i++ ){
        const { id, metafields: { number_in_bundle }} = filteredMetafields[i];
        if (allowBundle === false && number_in_bundle != 1) {
          continue; // Added to stop bundling
        }
        const bundleQuantityNeeded = Math.floor(quantityToFulfill / number_in_bundle);

        if (bundleQuantityNeeded === 0) continue
        data.push({
          id: id,
          quantity: bundleQuantityNeeded,
          location: custShipLocation
        })
        quantityToFulfill = quantityToFulfill - bundleQuantityNeeded * number_in_bundle
      }
      return data
}

const filterCartMetafields = (currentMetafields, quantity=null, isBundle = true) => {
  let filteredMetafields = [ ...currentMetafields ];
    //Filtering based on wholesale variants
    if (isBundle === true) {
      filteredMetafields = filterMetafieldsByWholeSale(filteredMetafields)
    }
    
    //Filtering based on upper and lower bound quantities
    if (isBundle === true && quantity !== null) {
      filteredMetafields = filterMetafieldsByQuantity(quantity, filteredMetafields)
    }
    
    //Filtering based by customers country based on cookie
    filteredMetafields = filterMetafieldsByCountry(custShipLocation, quantity, filteredMetafields, !isBundle)
    
    //Sorting metafields based on bundle count to put largest bundle sizes on top
    if (isBundle === true) {
      filteredMetafields = sortMetafieldsByBundleCount(filteredMetafields)
    }

    return filteredMetafields
}

const verifyCartContents = (cart, allowBundle = false, animate = true, noReload = false, callback = () => null) => {
    const productsInCart = {};

    const _idsInCart = cart.items.map(({ id }) => String(id));
    const variant_ids = [];
    const cartData = [];

    for (let i = 0; i < cart.items.length;i++){
      const item = cart.items[i];
      const { variant_id, product_id, quantity, properties = {} } = item

      if (properties !== null && properties['_free'] !== undefined) {
        const linkedProductKey = properties['_free'];

        const [ amount, linkedProductId ] = linkedProductKey.split('-');
        variant_ids.push(linkedProductId);

        cartData.push({
          id: linkedProductId,
          quantity: Number(quantity) * Number(amount),
          location: custShipLocation,
          properties: {
            '_freeItem': true
          }
        });
      }

      if (properties !== null && properties['_freeItem'] !== undefined) {
        variant_ids.push(variant_id);
      }
      const metafields = cart_product_variants_meta[product_id]
      if (!metafields || metafields.length === 0){
          continue
      }
      const matchedMetafield = metafields.find(_m => _m.id === variant_id)
      if (!matchedMetafield) continue;
      const number_in_bundle = matchedMetafield.metafields.number_in_bundle
      if (productsInCart[product_id]){
          productsInCart[product_id] = productsInCart[product_id] + (quantity * Number(number_in_bundle));
      } else {
          productsInCart[product_id] = (quantity * Number(number_in_bundle));
      }
    }

    const productIdsInCart = Object.keys(productsInCart)

    let reloadNeeded = false;


    for (let i = 0; i < productIdsInCart.length ; i++){
        const productId = productIdsInCart[i];
        const quantity = productsInCart[productId];
        const filteredMetafields = filterCartMetafields(cart_product_variants_meta[productId], quantity);
        const cartBundles = fillCartWithAppropriateBundles(quantity, filteredMetafields, allowBundle);
        
        cartData.push(...cartBundles);

        if (cart.items.length > cartBundles.length) {
          reloadNeeded = true;
        } else if (cart.items.length === cartBundles.length) {
          const new_ids = cartBundles.map(({ id }) => id);
          const old_ids = cart.items.map(({ id }) => id);
          
          if (new_ids.every((_) => old_ids.includes(_)) === false) {
            reloadNeeded = true;
          }
        }
        
        for ( let j=0;j<cart_product_variants_meta[productId].length;j++){
            const { id } = cart_product_variants_meta[productId][j]
            variant_ids.push(id)
        }
    }


    handleCartUpdate(variant_ids, cartData, animate, reloadNeeded, noReload, callback);
}

const handleCartUpdate = (variant_ids, cartData, animate, reloadNeeded, noReload, callback = () => null) => {
  if (typeof removeFromCart !== 'function' || typeof addMultipleToCart !== 'function') {
    setTimeout(() => handleCartUpdate(variant_ids, cartData, animate, reloadNeeded, noReload, callback), 100);
    return;
  }

  removeFromCart(variant_ids, () => {
    addMultipleToCart(cartData, true, animate, () => {
      if (noReload === false && window.location.pathname == '/cart' && reloadNeeded === true) {
        window.location.reload(true);
      }

      callback();
    });
  });
}

function addEventToCartPayments() {
  const cart_payment_options = document.querySelectorAll('.additional-checkout-buttons ul li div');

  if (cart_payment_options === undefined || cart_payment_options.length === 0) {
    setTimeout(addEventToCartPayments, 100);
    return;
  }
    
  cart_payment_options.forEach((_) => {
    var new_element = _.cloneNode(true);
    _.parentNode.append(new_element);

    new_element.id = "override-button";
    new_element.style.position = 'absolute !important';
    new_element.style.zIndex = '1 !important';
    new_element.style.top = '0 !important';

    _.parentNode.id = "override-button-container";

    new_element.addEventListener('click', (e) => {
      e.preventDefault();

      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        success(cart) {
          verifyCartContents(cart, true, false, true, () => _.click());
        }
      });
    }, true);
  });
}

function addEventToCart() {
  const cart_forms = document.querySelector('#cart_form');
  
  if (cart_forms === undefined) {
    setTimeout(addBundleLogic, 100);
    return;
  }

  cart_forms.addEventListener('submit', (e) => {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      success(cart) {
        verifyCartContents(cart, true, false, true);
      }
    });
  });
}

function initAddToCartBundle () {
  custShipLocation = getCookie('customer_ship_location');

  if (product_variants_meta == null) {
    return;
  }

  let initialFilteredMetafields = filterMetafieldsByCountry(custShipLocation, 1, [ ...product_variants_meta ])
  initialFilteredMetafields = filterForSingleBundle(initialFilteredMetafields)
  const amountAtLocation = filterMetafieldsByWholeSale(initialFilteredMetafields)
  
  if (amountAtLocation.length === 0){
    $('#add_to_cart_btn').addClass('disabled')
    $('#add_to_cart_btn_text').text("Sold out")
  }
  else {
    $('#add_to_cart_btn').removeClass('disabled')
    $('#add_to_cart_btn_text').text("Add To Cart")
  }

  $('.quantity-input').trigger('change');
}

function initAddToCart () {
  custShipLocation = getCookie('customer_ship_location');

  if (product_variants_meta == null) {
    return;
  }

  let amountAtLocation = filterMetafieldsByCountry(custShipLocation, 1, [ ...product_variants_meta ], true)
  
  if (amountAtLocation.length === 0){
    $('#add_to_cart_btn').addClass('disabled')
    $('#add_to_cart_btn_text').text("Sold out")
  }
  else {
    $('#add_to_cart_btn').removeClass('disabled')
    $('#add_to_cart_btn_text').text("Add To Cart")
  }



  $('.quantity-input').trigger('change');
}
